<template>
  <div class="account-balances-widget-container account-balances-widget-container--glass">
    <div v-if="loading" class="dashboard-widget-glass-state">
      <i class="bi bi-arrow-repeat dashboard-widget-glass-spinner" aria-hidden="true"></i>
      <span>Loading balances…</span>
    </div>
    <div v-else-if="error" class="dashboard-widget-glass-state dashboard-widget-glass-state--error">
      <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
      <span>{{ error }}</span>
    </div>
    <div v-else class="dashboard-widget-glass-table-section consultant-glass-table-section">
      <div class="consultant-glass-table-responsive consultant-glass-table-responsive--framed">
        <div class="consultant-glass-table-scroll-x">
          <table class="consultant-glass-table account-balances-widget-table">
            <thead>
              <tr>
                <th>Account</th>
                <th class="dashboard-widget-glass-amount-header">Balance</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="accounts.length === 0">
                <tr>
                  <td colspan="2" class="consultant-glass-table-no-records">No accounts found</td>
                </tr>
              </template>
              <template v-else>
                <tr
                  v-for="(account, index) in accounts"
                  :key="account.id"
                  class="consultant-glass-table-row"
                  :style="{ animationDelay: `${0.04 + index * 0.03}s` }"
                >
                  <td>{{ account.accountName }}</td>
                  <td
                    class="dashboard-widget-glass-amount-cell"
                    :class="{ 'dashboard-widget-glass-amount-cell--empty': !account.balance }"
                  >{{ formatCurrency(account.balance) }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './styles/AccountBalancesWidget.css';
import ApiService from '@/services/api.service';
import logger from '@/utils/logger';

export default {
  name: 'AccountBalancesWidget',
  props: {
    companyId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      accounts: [],
      loading: true,
      error: null,
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = null;
      try {
        const response = await ApiService.get(`/company-account/company/${this.companyId}`);
        const accountsData = Array.isArray(response.data) ? response.data : (response.data?.accounts || []);

        this.accounts = accountsData
          .filter((acc) => acc.active !== false)
          .map((acc) => ({
            id: acc.id,
            accountName: acc.accountName || acc.name,
            accountNumber: acc.accountNumber,
            balance: parseFloat(acc.currentBalance || acc.balance || 0),
          }))
          .filter((acc) => acc.balance !== 0)
          .sort((a, b) => Math.abs(b.balance) - Math.abs(a.balance))
          .slice(0, 10);
      } catch (error) {
        logger.error('Error fetching account balances:', error);
        this.error = 'Failed to load data';
      } finally {
        this.loading = false;
      }
    },
    formatCurrency(amount) {
      if (amount === null || amount === undefined || isNaN(amount)) return '$0.00';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    },
  },
};
</script>
